const getBanner = data => ({
    type: 'BANNER',
    data
})

export { getBanner }